export default class SigninState {
  email = ''
  password = ''
  disabled = false
  signedin = false
}
